// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__tFGS6","bannerParagraph":"Banner_bannerParagraph__Viosy","bannerBtn":"Banner_bannerBtn__RMlqu","shimmer":"Banner_shimmer__ALFnE"};